export default "__VITE_ASSET__D4jwM7mK__"